import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { type GroupMainType, useLoadGroup } from '@/entities/Group/Main'

export const useGroupMain = defineStore('group_main', () => {
  const group = ref<GroupMainType | null>(null)

  /**
   * Функция загрузки данных о группе
   */
  const loadGroupMainData = () => {
    const result = useLoadGroup()

    watch(result.data, () => {
      if (result.data.value) group.value = result.data.value.data
    })

    return result
  }

  return {
    group,
    loadGroupMainData,
  }
})
